"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
exports.default = () => styles_1.createStyles({
    root: {
        display: 'flex',
        alignItems: 'center'
    },
    anchor: {
        display: 'inline-flex',
        alignItems: 'center'
    },
    content: {
        fontSize: 'inherit'
    }
});
//# sourceMappingURL=styles.js.map